import {createSlice, createAsyncThunk}		from '@reduxjs/toolkit';

import {Contract, ContractState}						from './interface';
import actions 								from './contractsAction';


const initialState: ContractState = {
	isLoad:    false,
	isLoadPut: false,
	data:      []
};

export const getContractsApi = createAsyncThunk('contract/getContractsApi', actions.getContractsApi);
export const putContractsApi = createAsyncThunk('contract/putContractsApi', actions.putContractsApi);

export const Reducer = createSlice({
	name:     'contract',
	initialState,
	reducers: {
	},
	extraReducers: (builder) => {
		builder
		// --- GET
		.addCase(getContractsApi.pending, (state) => {
			state.isLoad = true;
		})
		.addCase(getContractsApi.fulfilled, (state, action) => {
			return ({
				...state,
				isLoad: false,
				data:   action.payload
			});
		})
		// --- PUT
		.addCase(putContractsApi.pending, (state) => {
			state.isLoadPut = true;
		})
		.addCase(putContractsApi.fulfilled, (state, action) => {
			if (!action.payload?._id)
				return ({...state, isLoadPut: false});

			const copy: Contract[] = state.data.map((contract) => {
				if (contract && action.payload._id === contract._id)
					return {...contract, ...action.payload};
				return contract;
			});

			return ({
				...state,
				data:      copy,
				isLoadPut: false
			});
		});
	}
});

// export const {logout} = Reducer.actions;

export default Reducer.reducer;
